import { render, staticRenderFns } from "./PointRule.vue?vue&type=template&id=af92e3d8"
import script from "./PointRule.vue?vue&type=script&lang=js"
export * from "./PointRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports